import * as React from "react";

import styles from "./footer.module.scss";

export type FooterConfiguration = {
    Button?: JSX.Element,
}

type FooterProps = {
    config: FooterConfiguration;
}

const Footer = (props: FooterProps) => {
    const { Button } = props.config;
    return (
        <div className={styles.footer}>
            <div className={styles.buttonContainer}>
                {Button}
            </div>
        </div>
    );
};

export default Footer;
